module.exports = __webpack_public_path__ + "static/media/bottom_left_sparkles.0fd7cc2c.png";